import { formatTL as fmt } from "@/lib/api";

const styles = `
  @page { size: 72mm auto; margin: 0; }
  * { margin: 0; padding: 0; box-sizing: border-box; }
  html, body { width: 72mm; }
  body { font-family: 'Courier New', monospace; color: #000; padding: 2mm 5mm 2mm 1mm; }
  .ticket { width: 100%; margin: 0 0 24px; padding-bottom: 12px; overflow-wrap: anywhere; }
  .center { text-align: center; }
  .brand { font-size: 18px; font-weight: 900; letter-spacing: 0; }
  .tag { display:inline-block; border:2px solid #000; padding:2px 10px; font-weight:700; margin-top:6px; }
  .num { font-size: 34px; font-weight: 900; margin: 6px 0; }
  hr { border: none; border-top: 1px dashed #000; margin: 8px 0; }
  .row { display: flex; justify-content: space-between; gap: 6px; font-size: 13px; margin: 3px 0; }
  .item { font-size: 14px; margin: 5px 0; }
  .item .name { font-weight: 700; }
  .note { font-size: 12px; font-weight: 700; padding-left: 12px; color: #000; }
  .total { font-size: 17px; font-weight: 900; }
  .muted { font-size: 12px; font-weight: 700; color: #000; }
  .wait { font-size: 13px; font-weight: 900; text-transform: uppercase; padding: 4px 0; }
  .kitchen .qty { font-size: 24px; font-weight: 900; }
  .kitchen .item { font-size: 24px; font-weight: 900; margin: 8px 0; line-height: 1.15; }
  .kitchen .note { font-size: 20px; font-weight: 800; font-style: normal; padding-left: 4px; line-height: 1.2; margin-top: 3px; }
  .kitchen .muted { font-size: 16px; font-weight: 700; color: #000; }
  .kitchen .row { font-size: 17px; }
  .kitchen .total { font-size: 20px; }
  .kitchen .num { font-size: 44px; }
  .kitchen .tag { font-size: 18px; }
  @media print { .ticket { page-break-after: always; } }
`;

const header = (order, label) => `
  <div class="center">
    <div class="brand">Deny's Burger &amp; Fries</div>
    <div class="tag">${label}</div>
    <div class="num">#${order.order_number}</div>
    <div class="muted">${order.order_type} · ${new Date(
  order.created_at || Date.now()
).toLocaleString("tr-TR")}</div>
  </div>
  ${
    order.order_type === "Paket Servis"
      ? `<hr/><div class="center" style="font-size:13px;font-weight:700;">📦 PAKET SERVİS</div>
         <div class="center muted">${order.customer_name || ""} · ${order.customer_phone || ""}</div>
         <div class="center muted">${order.customer_address || ""}</div>`
      : order.customer_phone
      ? `<hr/><div class="center muted">Müşteri Tel: ${order.customer_phone}${
          order.customer_name ? " · " + order.customer_name : ""
        }</div>`
      : ""
  }
  <hr/>
`;

const customerTicket = (order) => {
  const items = order.items
    .map(
      (it) => `
        <div class="item">
          <div class="row"><span class="name">${it.quantity}× ${it.name}</span><span>${fmt(
        it.price * it.quantity
      )}</span></div>
          ${it.note ? `<div class="note">↳ ${it.note}</div>` : ""}
        </div>`
    )
    .join("");
  return `
    <div class="ticket">
      ${header(order, "MÜŞTERİ FİŞİ")}
      ${items}
      <hr/>
      ${order.discount_amount > 0 ? `<div class="row"><span>İndirim (${order.discount_code})</span><span>-${fmt(order.discount_amount)}</span></div>` : ""}
      <div class="row"><span>Ara Toplam (KDV hariç)</span><span>${fmt(order.subtotal)}</span></div>
      <div class="row"><span>KDV (%10) dahil</span><span>${fmt(order.tax)}</span></div>
      <div class="row total"><span>TOPLAM (KDV dahil)</span><span>${fmt(order.total)}</span></div>
      <hr/>
      <div class="center wait">Lütfen sipariş numaranızın okunmasını bekleyin</div>
      <hr/>
      <div class="center muted">Ödeme: ${order.payment_method}</div>
      <div class="center muted">Afiyet olsun! · Deny's Burger &amp; Fries</div>
    </div>`;
};

const kitchenTicket = (order) => {
  const items = order.items
    .map(
      (it) => `
        <div class="item">
          <span class="qty">${it.quantity}×</span> <span class="name">${it.name}</span>
          ${it.note ? `<div class="note">↳ ${it.note}</div>` : ""}
        </div>`
    )
    .join("");
  return `
    <div class="ticket kitchen">
      ${header(order, "MUTFAK FİŞİ")}
      ${items}
      <hr/>
      <div class="center muted">${order.items.reduce(
        (s, i) => s + i.quantity,
        0
      )} ürün · ${order.order_type}</div>
      <hr/>
      <div class="row total"><span>TOPLAM</span><span>${fmt(order.total)}</span></div>
      <div class="row total"><span>ÖDEME</span><span>${/kredi|kart/i.test(order.payment_method || "") ? "KREDİ KARTI" : /nakit/i.test(order.payment_method || "") ? "NAKİT" : (order.payment_method || "-")}</span></div>
    </div>`;
};

export const printReceipt = (order, mode = "both") => {
  if (getPrinterMode() !== "browser") return printRawBT(order, mode);
  let body = "";
  if (mode === "customer" || mode === "both") body += customerTicket(order);
  if (mode === "kitchen" || mode === "both") body += kitchenTicket(order);

  const win = window.open("", "_blank", "width=380,height=640");
  if (!win) return;
  win.document.write(
    `<html><head><title>Fiş #${order.order_number}</title><style>${styles}</style></head><body>${body}</body></html>`
  );
  win.document.close();
  win.focus();
  setTimeout(() => {
    win.print();
  }, 300);
};

// Popup engellerini aşmak için gizli iframe ile otomatik yazdırma (kullanıcı tıklaması gerekmez)
export const printReceiptFrame = (order, mode = "kitchen") => {
  if (getPrinterMode() !== "browser") return printRawBT(order, mode);
  let body = "";
  if (mode === "customer" || mode === "both") body += customerTicket(order);
  if (mode === "kitchen" || mode === "both") body += kitchenTicket(order);

  const iframe = document.createElement("iframe");
  iframe.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;";
  document.body.appendChild(iframe);
  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(
    `<html><head><title>Fiş #${order.order_number}</title><style>${styles}</style></head><body>${body}</body></html>`
  );
  doc.close();
  setTimeout(() => {
    try {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    } catch (e) {}
    setTimeout(() => document.body.removeChild(iframe), 1500);
  }, 400);
};

// --- RawBT (Android USB fiş yazıcısı, ESC/POS) ---
const PRINTER_KEY = "fb_printer_mode";
export const getPrinterMode = () => localStorage.getItem(PRINTER_KEY) || "browser";
export const setPrinterMode = (m) => localStorage.setItem(PRINTER_KEY, m);

const COLS = 44;
const BIG_COLS = 20;
const TR = { ç: "c", Ç: "C", ğ: "g", Ğ: "G", ı: "i", İ: "I", ö: "o", Ö: "O", ş: "s", Ş: "S", ü: "u", Ü: "U", "×": "x", "₺": "TL", "↑": ">", "↳": ">", "·": "-" };
const ascii = (s) => String(s ?? "").replace(/[^\x20-\x7E]/g, (c) => TR[c] ?? "");
const money = (n) => ascii(fmt(n)).replace(/\s/g, "").replace(/^TL/, "") + " TL";
const line = (l, r, cols = COLS) => {
  const L = ascii(l), R = ascii(r);
  const space = cols - L.length - R.length;
  return space > 0 ? L + " ".repeat(space) + R : L.slice(0, cols - R.length - 1) + " " + R;
};
const ESC = "\x1b", GS = "\x1d";
const C = { init: ESC + "@", center: ESC + "a\x01", left: ESC + "a\x00", bold: ESC + "E\x01", nobold: ESC + "E\x00", big: GS + "!\x11", huge: GS + "!\x22", normal: GS + "!\x00", cut: GS + "V\x42\x03" };
const dash = "-".repeat(COLS) + "\n";
const payLabel = (p) => (/kredi|kart/i.test(p || "") ? "KREDI KARTI" : /nakit/i.test(p || "") ? "NAKIT" : ascii(p || "-"));

const escHeader = (o, label) => {
  let s = C.center + C.bold + C.big + "Deny's Burger & Fries\n" + C.normal + label + "\n" + C.huge + "#" + o.order_number + "\n" + C.normal + C.nobold;
  s += ascii(`${o.order_type} - ${new Date(o.created_at || Date.now()).toLocaleString("tr-TR")}`) + "\n";
  if (o.order_type === "Paket Servis") s += C.bold + "PAKET SERVIS\n" + C.nobold + ascii(`${o.customer_name || ""} ${o.customer_phone || ""}`) + "\n" + ascii(o.customer_address || "") + "\n";
  else if (o.customer_phone) s += ascii(`Musteri Tel: ${o.customer_phone} ${o.customer_name || ""}`) + "\n";
  return s + C.left + dash;
};

const escCustomer = (o) => {
  let s = escHeader(o, "MUSTERI FISI");
  o.items.forEach((it) => {
    s += C.bold + line(`${it.quantity}x ${it.name}`, money(it.price * it.quantity)) + "\n" + C.nobold;
    if (it.note) s += ascii(`  > ${it.note}`) + "\n";
  });
  s += dash;
  if (o.discount_amount > 0) s += line(`Indirim (${o.discount_code})`, "-" + money(o.discount_amount)) + "\n";
  s += line("Ara Toplam (KDV haric)", money(o.subtotal)) + "\n" + line("KDV (%10) dahil", money(o.tax)) + "\n";
  s += C.bold + C.big + line("TOPLAM", money(o.total), BIG_COLS) + "\n" + C.normal + C.nobold;
  s += dash + C.center + C.bold + "LUTFEN SIPARIS NUMARANIZIN\nOKUNMASINI BEKLEYIN\n" + C.nobold + dash;
  s += "Odeme: " + payLabel(o.payment_method) + "\nAfiyet olsun!\n\n\n" + C.left;
  return s + C.cut;
};

const escKitchen = (o) => {
  let s = escHeader(o, "MUTFAK FISI");
  o.items.forEach((it) => {
    s += C.bold + C.big + ascii(`${it.quantity}x ${it.name}`) + "\n";
    if (it.note) s += ascii(`  > ${it.note}`) + "\n";
    s += C.normal + C.nobold;
  });
  s += dash + C.center + C.bold + ascii(`${o.items.reduce((a, i) => a + i.quantity, 0)} urun - ${o.order_type}`) + "\n" + C.nobold + C.left + dash;
  s += C.bold + C.big + line("TOPLAM", money(o.total), BIG_COLS) + "\n" + line("ODEME", payLabel(o.payment_method), BIG_COLS) + "\n" + C.normal + C.nobold + "\n\n\n";
  return s + C.cut;
};

export const buildEscPos = (order, mode = "both") => {
  let s = C.init;
  if (mode === "customer" || mode === "both") s += escCustomer(order);
  if (mode === "kitchen" || mode === "both") s += escKitchen(order);
  return s;
};

export const printRawBT = (order, mode = "both") => {
  const b64 = btoa(buildEscPos(order, mode));
  if (getPrinterMode() === "rawbt2") {
    window.location.href = `rawbt:base64,${b64}`;
    return;
  }
  const url = `intent:base64,${b64}#Intent;scheme=rawbt;package=ru.a402d.rawbtprinter;end;`;
  if (window.fully && typeof window.fully.startIntent === "function") {
    try { return window.fully.startIntent(url); } catch (e) {}
  }
  const a = document.createElement("a");
  a.href = url;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  setTimeout(() => a.remove(), 1000);
};
